import {timestamp} from "rxjs/operator/timestamp";
/**
 * Created by nijin on 19/1/17.
 */
export class Schema{

  constructor(accountId?, isStationary?){
    this.accountId = accountId;
    this.timestamp ='';
    this.stationary = isStationary;
    this.predefinedLocation = false;
    this.attributes = [];
    this.location = new Array<LocationAttribute>();
  }
  id: number;
  accountId: number;
  name: string;
  description: string;
  stationary:boolean;
  predefinedLocation:boolean;
  type: SchemaType
  category: SchemaCategory
  location: Array<LocationAttribute>
  timestamp: any;
  attributes: Array<SchemaAttribute>
}

export class SchemaType{

  id: number;
  name: string
}

export class SchemaCategory{
  id: number;
  name: string;
}

export class LocationAttribute{
  constructor(){
    this.fields = [];
  }
  name: string;
  dataType: string;
  precision:number;
  required: boolean;
  fields: Array<LocationFields>
}
export class LocationFields{
  constructor(){

  }
  name: string;
  dataType: string;
  precision: number;
  required: boolean
}

export class SchemaAttribute{
  constructor(){

  }
  name: string;
  dataType: string;
  unit: string;
  precision: number;
  required: boolean
}

export class EventData{
  constructor(){
    this.location = {};
    this.attributes = {};
  }
  accountId: string;
  deviceId: string;
  timestamp: number;
  stationary: boolean;
  predefinedLocation:boolean;
  location : any;
  attributes : any;
}



// WEBPACK FOOTER //
// ./src/app/schema/model/schema.model.ts